<template>
  <div>
    <div class="hidden-wrap" :class="{ 'hidden-in-padding': content }">
      <el-tooltip
        v-if="tooltip && moreShowStatus"
        effect="dark"
        :content="content"
        placement="top"
        popper-class="main-menu-tool-tip"
        :enterable="false"
      >
        <div
          ref="hidden"
          :class="{ wrap: hiddenStatus }"
          :style="'-webkit-line-clamp: ' + line"
        >
          {{ content }}
        </div>
      </el-tooltip>
      <div
        ref="hidden"
        :class="{ wrap: hiddenStatus }"
        :style="'-webkit-line-clamp: ' + line"
        v-else
      >
        {{ content }}
      </div>

      <i
        class="view-more"
        v-if="moreShowStatus"
        :class="{ fold: !hiddenStatus }"
        @click="hiddenStatus = !hiddenStatus"
      ></i>
    </div>
    <div class="truth-box" ref="truth" v-if="showStatus">
      {{ content }}
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: "TextOverflow",
  props: {
    line: {
      type: [Number, String],
      require: true,
      default: 1
    },
    content: {
      type: String,
      require: true,
      default: ''
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    content(newVal) {
      if (newVal) {
        this.checkIsOverFlow()
      }
    }
  },
  data () {
    return {
      showStatus: true,
      moreShowStatus: false,
      hiddenStatus: true,
    }
  },
  mounted () {
    this.checkIsOverFlow()
  },
  methods: {
    checkIsOverFlow() {
      this.moreShowStatus = false
      this.showStatus = true
      this.hiddenStatus = true
      const _this = this
      this.$nextTick(function () {
        const hidden = _this.$refs['hidden'].offsetHeight
        const truth = _this.$refs['truth'].offsetHeight
        if (hidden < truth) this.moreShowStatus = true
        this.showStatus = false
      })
    }
  },
}
</script>
<style lang="scss">
.wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}
</style>
<style lang="scss" scoped>
.mb-19 {
  margin-bottom: 19px !important;
}
.truth-box {
  position: absolute;
  opacity: 0;
}

.hidden-wrap {
  position: relative;
  &.hidden-in-padding {
    padding-bottom: 16px;
  }
  &:hover .view-more {
    display: block;
  }
  .view-more {
    display: none;
    cursor: pointer;
    content: '';
    width: 24px;
    height: 24px;
    position: absolute;
    right: -2px;
    bottom: -3px;
    //background: center url('../images/arrow.svg') no-repeat;
    transform: rotate(-180deg);
    transition: 0.3s;

    &.fold {
      transform: rotate(0deg);
    }
  }
}
.is-mobile {
  .hidden-wrap {
    .view-more {
      display: block;
    }
  }
}
</style>
